import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyInfoResponse, HttpResponse } from "@/types";

export const candidacyInfoQueryKey = (
  companyId: string | undefined,
  jobId: string | undefined,
  candidacyId: string,
) => ["candidacy-info", companyId, jobId, candidacyId] as const;

export function useGetCandidacyInfo({ candidacyId }: { candidacyId: string }) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: candidacyInfoQueryKey(
      currentCompanyId,
      currentJobId,
      candidacyId,
    ),
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/info`;
      const res = await guacHttpClient.get<
        CandidacyInfoResponse,
        HttpResponse<CandidacyInfoResponse>
      >(path);
      return res.data;
    },
    enabled: !!candidacyId,
    placeholderData: (previousData) => previousData,
    // Many sheet children observe this key. After a failure, mounting another
    // child must not turn one error into a burst of identical requests.
    retry: false,
    retryOnMount: false,
  });
}
